var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.2 11.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,5.2c0,0,0.3,0,1.7,0c1.4,0,1.2-2.6,2.6-2.6c1.6,0,0.9,2.6,1.7,2.6C6.9,5.2,6.8,0,8.7,0s2.5,7,3.5,7 c1,0,0.9-5.2,2.6-5.2c1.7,0,1.5,3.5,2.6,3.5c1.1,0,1.7,0,1.7,0V7c0,0-1,0-2.3,0c-1.3,0-1.5-1.7-2.1-1.7c-0.6,0-0.4,6.1-2.6,6.1 c-2.2,0-2.3-7-3.5-7c-0.9,0-1.2,5.2-2.6,5.2c-1.4,0-1.3-3.5-1.7-3.5C3.9,6.1,3.6,7,2.6,7C1.6,7,0,7,0,7V5.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizationIcon);
export default __webpack_public_path__ + "static/media/visualization-icon.6d9d0fb46496ad07f25d9be2a90d4816.svg";
export { ForwardRef as ReactComponent };